/**
 * Created by guanyj on  10/25/19
 */


export abstract class ChartCustomInterface {

    abstract queryStatByCustom(params: any): any;
}
